import { render, staticRenderFns } from "./shopintro.vue?vue&type=template&id=24a8ce72&scoped=true"
import script from "./shopintro.vue?vue&type=script&lang=js"
export * from "./shopintro.vue?vue&type=script&lang=js"
import style0 from "./shopintro.vue?vue&type=style&index=0&id=24a8ce72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a8ce72",
  null
  
)

export default component.exports